import { z } from "zod";

export default {
  params: z.object({
    accountId: z.string(),
    userId: z.number().int(),
    documentId: z.string(),
  }),
  response: z.void(),
};
